import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CaixaService } from 'app/service/caixa/caixa.service';

@Component({
  selector: 'app-gerar-rgs',
  templateUrl: './gerar-rgs.component.html',
  styleUrls: ['./gerar-rgs.component.scss']
})
export class GerarRgsComponent implements OnInit {

  public rgControl = new FormControl('');
  public rgsGerados;
  public loading = false;
  public listar = false;

  constructor(private caixaService: CaixaService) { }

  ngOnInit() {
  }

  getRgs() {
    this.loading = true;
    console.log(this.rgControl.value);
    this.caixaService.gerarRgs(this.rgControl.value).subscribe(data => {
      this.rgsGerados = data;
      this.loading = false;
      this.listar = true;
      this.rgControl.setValue('');
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  imprimir() {
    let rgsDownload = '';
    this.rgsGerados.map(element => {
      rgsDownload += element.rgRecipiente + '\n';
    });
    console.log(rgsDownload);
    this.download(rgsDownload);
  }

  download(text) {
    let date = new Date();
    let dateFormat = date.toLocaleDateString('pt-BR');
    let nameFile = 'rgs_' + dateFormat + '.txt';
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', nameFile);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/gerar-rgs/gerar-rgs.component.ts